import React from "react";
import styled from "styled-components";
import Group6449 from "../../img/tachograph/group-6449.png";
import Group7037 from "../../img/task-management/group-7037.png";
import ListIcon from "../../img/list-icon.svg";

const VehicleInspectionFirstContentWrapper = styled.div`
  padding: 0px 375px 200px;
  position: relative;
  z-index: 1;
  .container {
    padding: 100px 100px 70px;
    box-shadow: 0px 4px 20px #1a284d14;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    background-color: #fff;
    .container-cards {
      display: flex;
      align-items: center;
      .left {
        flex-basis: 75%;
        h2 {
          ${(props) => props.theme.h2_48};
          color: #202945;
          margin-bottom: 16px;
        }
        ul {
          padding-left: 24px;
          list-style-image: url(${ListIcon});
          li {
            ${(props) => props.theme.body_20};
            &:not(:last-child) {
              margin-bottom: 15px;
            }
          }
        }
      }

      .right {
        flex-basis: 25%;
        img {
          width: 370px;
          display: block;
        }
      }
      &:nth-child(2n) {
        .left {
          order: 1;
        }
      }
      &:not(:last-child) {
        margin-bottom: 175px;
      }
      &:last-child {
        img {
          box-shadow: none;
        }
      }
    }
  }
  @media (max-width: 1900px) {
    padding: 0px 275px 150px;
    .container {
      padding: 30px 25px 40px;
      .container-cards {
        .left {
          h2 {
            font-size: 38px;
            line-height: 53px;
          }
          p {
            font-size: 18px;
            line-height: 25px;
          }
        }
        &:not(:last-child) {
          margin-bottom: 75px;
        }
      }
    }
  }

  @media (max-width: 1439px) {
    padding: 0px 50px 100px;
  }
  @media (max-width: 1023px) {
    padding: 0px 20px 50px;
    .container {
      .container-cards {
        .left {
          h2 {
            font-size: 28px;
            line-height: 39px;
          }
          p {
            font-size: 15px;
            line-height: 21px;
          }
          ul {
            li {
              font-size: 15px;
              line-height: 21px;
            }
          }
        }
        .right {
          img {
            width: 250px;
          }
        }
      }
    }
  }

  @media (max-width: 767px) {
    .container {
      padding: 30px 15px 40px;
      .container-cards {
        display: block;
        .left {
          margin-right: 0;
          margin-bottom: 15px;
          h2 {
            margin-bottom: 10px;
          }
        }
        .right {
          img {
            margin: 0 auto;
          }
        }
        &:nth-child(2n) {
          .left {
            margin-left: 0;
          }
        }
        &:not(:last-child) {
          margin-bottom: 40px;
        }
      }
    }
  }
`;
const VehicleInspectionFirstContent = () => {
  return (
    <VehicleInspectionFirstContentWrapper>
      <div className="container">
        <div className="container-cards">
          <div className="left">
            <h2
              className="t"
              data-translate="vehicleInspectionFirstContentFirstCardTitle"
            >
              Save Time and Reduce Risks
            </h2>
            <ul>
              <li
                className="t"
                data-translate="vehicleInspectionFirstContentFirstCardText1"
              >
                Save time and space by using digital forms
              </li>
              <li
                className="t"
                data-translate="vehicleInspectionFirstContentFirstCardText2"
              >
                Design forms that fit your needs
              </li>
              <li
                className="t"
                data-translate="vehicleInspectionFirstContentFirstCardText3"
              >
                Schedule inspections to avoid missing them
              </li>
              <li
                className="t"
                data-translate="vehicleInspectionFirstContentFirstCardText4"
              >
                Reduce human error and catch issues before heading out on the
                road
              </li>
            </ul>
          </div>
          <div className="right">
            <img alt="" src={Group6449} />
          </div>
        </div>
        <div className="container-cards">
          <div className="left">
            <h2
              className="t"
              data-translate="vehicleInspectionFirstContentSecondCardTitle"
            >
              Customise to Fit Your Needs
            </h2>
            <ul>
              <li
                className="t"
                data-translate="vehicleInspectionFirstContentSecondCardText1"
              >
                Start with a template or use a simple drag and drop editor to
                customise the forms
              </li>
              <li
                className="t"
                data-translate="vehicleInspectionFirstContentSecondCardText2"
              >
                Set up a scheduled inspection frequency and your drivers will be
                notified when inspections are due
              </li>
              <li
                className="t"
                data-translate="vehicleInspectionFirstContentSecondCardText3"
              >
                Drivers can add photos, comments and documents to report defects
              </li>
              <li
                className="t"
                data-translate="vehicleInspectionFirstContentSecondCardText4"
              >
                Create different forms for specific vehicles
              </li>
            </ul>
          </div>
          <div className="right">
            <img alt="" src={Group7037} />
          </div>
        </div>
      </div>
    </VehicleInspectionFirstContentWrapper>
  );
};

export default VehicleInspectionFirstContent;
